/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgLabel = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M4 19v2H2v-2zm18 0v2h-2v-2zM7 19v2H5v-2zm4 0v2H9v-2zm4 0v2h-2v-2zm4 0v2h-2v-2zM4 15v2H2v-2zm18 0v2h-2v-2zM4 11v2H2v-2zm18 0v2h-2v-2zM7 11v2H5v-2zm4 0v2H9v-2zm4 0v2h-2v-2zm4 0v2h-2v-2zm-4-8v6H2V3zm-2 2H4v2h9z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgLabel as Label };
